import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, onUnmounted, inject, watch } from "vue";
import DateRangeSelector from "@/components/ui/date-range/DateRangeSelector.vue";
import { useDailyDateRange } from "@/composables/useDailyDateRange.ts";
export default {
  __name: 'DailyDateRangeSelector',
  props: {
    initialSelectedDay: {
      type: Date,
      required: false,
      default: null
    },
    selectedDay: {
      type: Object,
      required: false,
      default: null
    },
    dayRangeLength: {
      type: Number,
      required: false,
      default: 8
    }
  },
  emits: ["update:selected-day"],
  setup(__props, {
    emit: __emit
  }) {
    const requestStartDate = inject("requestStartDate");
    const props = __props;
    const emit = __emit;

    // Use the daily date range composable
    const {
      currentDay,
      isPreviousDisabled,
      getDailyRange,
      previousDay: prevDay,
      nextDay: nextDayFn,
      resetToCurrentDay: resetDay,
      setDay
    } = useDailyDateRange(props.dayRangeLength);

    // Emit day update with the current day data
    const emitDayUpdate = () => {
      const dailyRange = getDailyRange(props.dayRangeLength);
      emit("update:selected-day", {
        ...dailyRange
      });
    };
    watch(requestStartDate, () => {
      setDay(requestStartDate.value);
      emitDayUpdate();
    }, {
      immediate: false
    });

    // Wrapper functions to emit updates
    const previousDay = () => {
      prevDay();
      emitDayUpdate();
    };
    const nextDay = () => {
      nextDayFn();
      emitDayUpdate();
    };
    const resetToCurrentDay = () => {
      resetDay();
      emitDayUpdate();
    };

    // Initialize with current day
    onMounted(() => {
      // Only set current day if no prop value is provided
      if (!props.initialSelectedDay) {
        // Initialize with 2 days ago
        currentDay.value = new Date(new Date().setDate(new Date().getDate() - 2));
        emitDayUpdate();
      } else {
        setDay(props.initialSelectedDay);
        emitDayUpdate();
      }
    });
    onUnmounted(() => {
      resetToCurrentDay();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(DateRangeSelector, {
        "display-label": _unref(getDailyRange)().label,
        "is-previous-disabled": _unref(isPreviousDisabled),
        "previous-label": _ctx.$tf('timeManagement.previousDay.label'),
        "next-label": _ctx.$tf('timeManagement.nextDay.label'),
        "previous-tooltip": _ctx.$tf('timeManagement.previousDay.tooltip'),
        "next-tooltip": _ctx.$tf('timeManagement.nextDay.tooltip'),
        onPrevious: previousDay,
        onNext: nextDay,
        onReset: resetToCurrentDay,
        "width-of-label": "225px"
      }, null, 8, ["display-label", "is-previous-disabled", "previous-label", "next-label", "previous-tooltip", "next-tooltip"])]);
    };
  }
};